import { Box } from '@mui/material';
import { Component, type ErrorInfo, type PropsWithChildren } from 'react';
import { logUnexpectedError } from '#app/shared/utils/logging';
import { ErrorBox, ErrorBoxWithSignOut } from '../Errors/ErrorBox';

interface State {
  hasError: boolean;
}

interface Props extends PropsWithChildren {
  signOutOnError?: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logUnexpectedError(error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Box data-testid="errorboundary">
          {this.props.signOutOnError ? <ErrorBoxWithSignOut /> : <ErrorBox />}
        </Box>
      );
    }

    return <>{this.props.children}</>;
  }
}

export default ErrorBoundary;
